import { useTranslation } from 'react-i18next';
import { useContext } from 'react';

import Dashboard from 'features/Dashboard';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can, AbilityContext } from 'components/Can';
import TokenService from 'utils/axios/token.axios';
import { removeLocalStorage } from 'utils/func';

function DashboardPage() {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);

  if (ability.cannot('read', 'statistic')) {
    TokenService.removeUser();
    removeLocalStorage();
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  }

  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="statistic">
            <Dashboard />
          </Can>
          <Can not do="read" on="statistic">
            <h4 className="text-red-500">{t('permission.forbid.read.statistic')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default DashboardPage;
